import React, {FC} from "react";
import SpaceUsageCard from "../deprecatedUikit/SpaceUsageCard/SpaceUsageCard";
import SpaceUsageLoader from "../deprecatedUikit/SpaceUsageCard/SpaceUsageLoader";
import {Grid} from "@mui/material";
import {generateSupplierInvoicesLinkFromTransaction} from "../../util/LinkUtils";
import {formatRowAmount, isRefundRow, type PayoutTransaction} from "./payoutRowFormat";

const LoadingSkeleton = () => {
  return (
    <Grid container direction={'column'} gap={2}>
      {Array.from({length: 10}).map((_, index) => <SpaceUsageLoader key={index} />)}
    </Grid>
  );
};

interface IPayoutTransactionListProps {
  loading: boolean;
  payoutTransactions: PayoutTransaction[];
}

const PayoutTransactionList: FC<IPayoutTransactionListProps> = ({loading, payoutTransactions = []}) => {
  return (
    loading ? <LoadingSkeleton /> : payoutTransactions?.map((bookingTransaction) => {
      const refund = isRefundRow(bookingTransaction);
      return (
        <SpaceUsageCard
          data={{
            // @ts-expect-error TODO: fix typing in securspace-ui-kit
            invoiceNumber: bookingTransaction.transactionNumber,
            payoutAmount: formatRowAmount(bookingTransaction),
            chargeType: bookingTransaction.chargeType,
            serviceDates: bookingTransaction.serviceDates,
            paymentDate: bookingTransaction.paymentDate,
            buyer: bookingTransaction.buyerCompanyName,
            location: bookingTransaction.locationName,
            bookingNumber: bookingTransaction.orderNumber,
            paymentType: bookingTransaction.paymentType,
          }}
          variant={'primary'}
          key={bookingTransaction.transactionNumber}
          // TODO: Update link generation to include date range if needed
          links={{
            // @ts-expect-error TODO: createdOn is not a field of payout transaction, either add it to the api response or edit this link generation
            invoiceNumber: {baseUrl: `${generateSupplierInvoicesLinkFromTransaction(null, bookingTransaction?.createdOn)}&`, queryParam: "invoiceNumber"},
            bookingNumber: {baseUrl: '/bookings/supplier-bookings', queryParam: "bookingNumber"},
          }}
          styles={{
            mb: 2,
            width: '100%',
            ...(refund && {borderLeft: '4px solid', borderLeftColor: 'error.main'}),
          }}
        />
      );
    })
  );
};

export default PayoutTransactionList;
